var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gantt_container"},[(_vm.project==null)?_c('GanttOverview',{on:{"project":_vm.goTo}}):_vm._e(),(_vm.project!=null)?_c('GanttDiagram',{attrs:{"project":_vm.project},on:{"project":function($event){return _vm.goTo(null)}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }